// Sistema di routing per esperienze 3D con URL dedicati
// Permette ai clienti di accedere direttamente alle esperienze tramite URL condivisibili

import { appBase } from './routes'
import { AuthSystem } from './auth-system'

// Configurazioni delle esperienze disponibili
export interface ExperienceConfig {
  id: string
  name: string
  title: string
  description: string
  modelType: string
  defaultScale?: string
  defaultPosition?: string
  defaultRotation?: string
  allowedParams?: string[]
  requiresAuth: boolean
  category?: string
  envmap?: string[] // Array di URL per le texture del cubemap
  defaultCustomParams?: Record<string, string> // Parametri di default specifici del template
}

// Esperienze disponibili nel museo
export const EXPERIENCES: Record<string, ExperienceConfig> = {
  'castel-oggi': {
    id: 'castel-oggi',
    name: 'Castel Oggi',
    title: 'Castel Oggi - Vista Contemporanea',
    description: 'Esplora il Castel Oggi nella sua forma attuale con animazioni e interazioni immersive.',
    modelType: 'castelOggi',
    defaultScale: '0.7 0.7 0.7',
    defaultPosition: '0 0 -15',
    defaultRotation: '0 90 0',
    defaultCustomParams: {
      animation: 'no',
      repeat: 'yes',
      listAnim: '["Scene", "hiphop", "chicken"]',
      text: 'Avvia Animazione'
    },
    allowedParams: ['scale', 'position', 'rotation', 'animation', 'repeat', 'listAnim', 'text'],
    requiresAuth: true,
    category: 'castelli',
    envmap: [
      'https://raw.githubusercontent.com/mrdoob/three.js/master/examples/textures/cube/Bridge2/posx.jpg',
      'https://raw.githubusercontent.com/mrdoob/three.js/master/examples/textures/cube/Bridge2/negx.jpg',
      'https://raw.githubusercontent.com/mrdoob/three.js/master/examples/textures/cube/Bridge2/posy.jpg',
      'https://raw.githubusercontent.com/mrdoob/three.js/master/examples/textures/cube/Bridge2/negy.jpg',
      'https://raw.githubusercontent.com/mrdoob/three.js/master/examples/textures/cube/Bridge2/posz.jpg',
      'https://raw.githubusercontent.com/mrdoob/three.js/master/examples/textures/cube/Bridge2/negz.jpg'
    ]
  },

  // Versione camelCase per compatibilità QR (stesso di castel-oggi)
  'castelOggi': {
    id: 'castelOggi',
    name: 'Castel Oggi',
    title: 'Castel Oggi - Vista Contemporanea',
    description: 'Esplora il Castel Oggi nella sua forma attuale con animazioni e interazioni immersive.',
    modelType: 'castelOggi',
    defaultScale: '0.7 0.7 0.7',
    defaultPosition: '0 0 -15',
    defaultRotation: '0 90 0',
    defaultCustomParams: {
      animation: 'no',
      repeat: 'yes',
      listAnim: '["Scene", "hiphop", "chicken"]',
      text: 'Avvia Animazione'
    },
    allowedParams: ['scale', 'position', 'rotation', 'animation', 'repeat', 'listAnim', 'text'],
    requiresAuth: true,
    category: 'castelli',
    envmap: [
      'https://raw.githubusercontent.com/mrdoob/three.js/master/examples/textures/cube/Bridge2/posx.jpg',
      'https://raw.githubusercontent.com/mrdoob/three.js/master/examples/textures/cube/Bridge2/negx.jpg',
      'https://raw.githubusercontent.com/mrdoob/three.js/master/examples/textures/cube/Bridge2/posy.jpg',
      'https://raw.githubusercontent.com/mrdoob/three.js/master/examples/textures/cube/Bridge2/negy.jpg',
      'https://raw.githubusercontent.com/mrdoob/three.js/master/examples/textures/cube/Bridge2/posz.jpg',
      'https://raw.githubusercontent.com/mrdoob/three.js/master/examples/textures/cube/Bridge2/negz.jpg'
    ]
  },
  'castel-ieri': {
    id: 'castel-ieri',
    name: 'Castel Ieri',
    title: 'Castel Ieri - Vista Storica',
    description: 'Viaggia nel tempo e scopri come appariva il castello in epoca medievale.',
    modelType: 'castelIeri',
    defaultScale: '5 5 5',
    defaultPosition: '0 0 -15',
    defaultRotation: '0 0 0',
    defaultCustomParams: {
      animation: 'yes',
      repeat: 'yes',
      listAnim: '["Animation"]',
      text: 'Fai volare le Aquile'
    },
    allowedParams: ['scale', 'position', 'rotation', 'animation', 'repeat', 'listAnim', 'text', 'timePeriod'],
    requiresAuth: true,
    category: 'castelli',
    envmap: [
      'https://raw.githubusercontent.com/mrdoob/three.js/master/examples/textures/cube/Bridge2/posx.jpg',
      'https://raw.githubusercontent.com/mrdoob/three.js/master/examples/textures/cube/Bridge2/negx.jpg',
      'https://raw.githubusercontent.com/mrdoob/three.js/master/examples/textures/cube/Bridge2/posy.jpg',
      'https://raw.githubusercontent.com/mrdoob/three.js/master/examples/textures/cube/Bridge2/negy.jpg',
      'https://raw.githubusercontent.com/mrdoob/three.js/master/examples/textures/cube/Bridge2/posz.jpg',
      'https://raw.githubusercontent.com/mrdoob/three.js/master/examples/textures/cube/Bridge2/negz.jpg'
    ]
  },

  // Versione camelCase per compatibilità QR (stesso di castel-ieri)  
  'castelIeri': {
    id: 'castelIeri',
    name: 'Castel Ieri',
    title: 'Castel Ieri - Vista Storica',
    description: 'Viaggia nel tempo e scopri come appariva il castello in epoca medievale.',
    modelType: 'castelIeri',
    defaultScale: '5 5 5',
    defaultPosition: '0 0 -15',
    defaultRotation: '0 0 0',
    defaultCustomParams: {
      animation: 'yes',
      repeat: 'yes',
      listAnim: '["Animation"]',
      text: 'Fai volare le Aquile'
    },
    allowedParams: ['scale', 'position', 'rotation', 'animation', 'repeat', 'listAnim', 'text', 'timePeriod'],
    requiresAuth: true,
    category: 'castelli',
    envmap: [
      'https://raw.githubusercontent.com/mrdoob/three.js/master/examples/textures/cube/Bridge2/posx.jpg',
      'https://raw.githubusercontent.com/mrdoob/three.js/master/examples/textures/cube/Bridge2/negx.jpg',
      'https://raw.githubusercontent.com/mrdoob/three.js/master/examples/textures/cube/Bridge2/posy.jpg',
      'https://raw.githubusercontent.com/mrdoob/three.js/master/examples/textures/cube/Bridge2/negy.jpg',
      'https://raw.githubusercontent.com/mrdoob/three.js/master/examples/textures/cube/Bridge2/posz.jpg',
      'https://raw.githubusercontent.com/mrdoob/three.js/master/examples/textures/cube/Bridge2/negz.jpg'
    ]
  },
  'tuta-amianto': {
    id: 'tuta-amianto',
    name: 'Tuta Amianto',
    title: 'Tuta Protettiva Amianto',
    description: 'Esplora la tuta protettiva per lavori con amianto con controlli di movimento dettagliati.',
    modelType: 'tutaAmianto',
    defaultScale: '3.5 3.5 3.5',
    defaultPosition: '0 0 0',
    defaultRotation: '0 0 0',
    defaultCustomParams: {
      animation: 'no',
      repeat: 'yes',
      listAnim: '["Scene", "walk"]',
      text: 'Cambia Animazione'
    },
    allowedParams: ['scale', 'position', 'rotation', 'animation', 'repeat', 'listAnim', 'text', 'movement'],
    requiresAuth: true,
    category: 'sicurezza',
    envmap: [
      'https://raw.githubusercontent.com/mrdoob/three.js/master/examples/textures/cube/Bridge2/posx.jpg',
      'https://raw.githubusercontent.com/mrdoob/three.js/master/examples/textures/cube/Bridge2/negx.jpg',
      'https://raw.githubusercontent.com/mrdoob/three.js/master/examples/textures/cube/Bridge2/posy.jpg',
      'https://raw.githubusercontent.com/mrdoob/three.js/master/examples/textures/cube/Bridge2/negy.jpg',
      'https://raw.githubusercontent.com/mrdoob/three.js/master/examples/textures/cube/Bridge2/posz.jpg',
      'https://raw.githubusercontent.com/mrdoob/three.js/master/examples/textures/cube/Bridge2/negz.jpg'
    ]
  },

  'bleirot': {
    id: 'bleirot',
    name: 'Bleirot',
    title: 'Bleirot - Modello Storico',
    description: 'Scopri il modello Bleirot con le sue caratteristiche uniche e animazioni.',
    modelType: 'bleirot',
    defaultScale: '3 3 3',
    defaultPosition: '0 -5 -5',
    defaultRotation: '0 0 0',
    defaultCustomParams: {
      animation: 'yes',
      repeat: 'no',
      listAnim: '["Scene"]',
      text: 'Decolla'
    },
    allowedParams: ['scale', 'position', 'rotation', 'animation', 'repeat', 'listAnim', 'text', 'detail'],
    requiresAuth: true,
    category: 'modelli'
  },
  'castel-del-monte': {
    id: 'castel-del-monte',
    name: 'Castel del Monte',
    title: 'Castel del Monte - Gioiello Architettonico',
    description: 'Ammira la perfezione geometrica del Castel del Monte con dettagli architettonici.',
    modelType: 'casteldelmonte',
    defaultScale: '0.5 0.5 0.5',
    defaultPosition: '0 0 -5',
    defaultRotation: '0 0 0',
    defaultCustomParams: {
      animation: 'no',
      repeat: 'yes',
      listAnim: '["Scene", "rotate", "scale"]',
      text: 'Animazioni'
    },
    allowedParams: ['scale', 'position', 'rotation', 'animation', 'repeat', 'listAnim', 'text', 'geometry'],
    requiresAuth: true,
    category: 'castelli'
  },

  // Esperienze aggiuntive dal menu
  'palladicannone': {
    id: 'palladicannone',
    name: 'Palladi Cannone',
    title: 'Palladi Cannone',
    description: 'Modello 3D della Palladi Cannone con animazioni e interazioni.',
    modelType: 'palladicannone',
    defaultScale: '5 5 5',
    defaultPosition: '0 0 -15',
    defaultRotation: '0 0 0',
    defaultCustomParams: {
      animation: 'yes',
      repeat: 'no',
      listAnim: '["SphereAction"]',
      text: 'Fai uscire la palla di cannone'
    },
    allowedParams: ['scale', 'position', 'rotation', 'animation', 'repeat', 'listAnim', 'text'],
    requiresAuth: true,
    category: 'militare'
  },


  'forno': {
    id: 'forno',
    name: 'Forno',
    title: 'Forno',
    description: 'Modello 3D del Forno con animazioni e interazioni.',
    modelType: 'forno',
    defaultScale: '10 10 10',
    defaultPosition: '0 0 -10',
    defaultRotation: '0 0 0',
    defaultCustomParams: {
      animation: 'yes',
      repeat: 'yes',
      listAnim: '["Animation"]',
      text: 'Accendi il forno'
    },
    allowedParams: ['scale', 'position', 'rotation', 'animation', 'repeat', 'listAnim', 'text'],
    requiresAuth: true,
    category: 'industria'
  },

  'mitragliatrice': {
    id: 'mitragliatrice',
    name: 'Mitragliatrice',
    title: 'Mitragliatrice',
    description: 'Modello 3D della Mitragliatrice con animazioni e interazioni.',
    modelType: 'mitragliatrice',
    defaultScale: '10 10 10',
    defaultPosition: '2 0 -5',
    defaultRotation: '0 0 0',
    defaultCustomParams: {
      animation: 'yes',
      repeat: 'no',
      listAnim: '["Animation"]',
      text: 'Spara'
    },
    allowedParams: ['scale', 'position', 'rotation', 'animation', 'repeat', 'listAnim', 'text'],
    requiresAuth: true,
    category: 'militare'
  },

  // Versioni camelCase per compatibilità QR
  'tutaAmianto': {
    id: 'tutaAmianto',
    name: 'Tuta Amianto',
    title: 'Tuta Protettiva Amianto',
    description: 'Esplora la tuta protettiva per lavori con amianto con controlli di movimento dettagliati.',
    modelType: 'tutaAmianto',
    defaultScale: '3.5 3.5 3.5',
    defaultPosition: '0 0 0',
    defaultRotation: '0 0 0',
    defaultCustomParams: {
      animation: 'no',
      repeat: 'yes',
      listAnim: '["Scene", "walk"]',
      text: 'Cambia Animazione'
    },
    allowedParams: ['scale', 'position', 'rotation', 'animation', 'repeat', 'listAnim', 'text', 'movement'],
    requiresAuth: true,
    category: 'sicurezza'
  },

  'casteldelmonte': {
    id: 'casteldelmonte',
    name: 'Castel del Monte',
    title: 'Castel del Monte - Gioiello Architettonico',
    description: 'Ammira la perfezione geometrica del Castel del Monte con dettagli architettonici.',
    modelType: 'casteldelmonte',
    defaultScale: '0.5 0.5 0.5',
    defaultPosition: '0 0 -5',
    defaultRotation: '0 0 0',
    defaultCustomParams: {
      animation: 'no',
      repeat: 'yes',
      listAnim: '["Scene", "rotate", "scale"]',
      text: 'Animazioni'
    },
    allowedParams: ['scale', 'position', 'rotation', 'animation', 'repeat', 'listAnim', 'text', 'geometry'],
    requiresAuth: true,
    category: 'castelli'
  },

  // Nuova esperienza: Ologramma Milone (Aerofono)
  'ologramma-milone': {
    id: 'ologramma-milone',
    name: 'Ologramma Milone - Aerofono',
    title: 'Ologramma Milone - Aerofono',
    description: "Esperienza video ologramma con chroma key dell'Aerofono (Milone).",
    modelType: 'ologramma',
    // Default derivati dalla struttura in /ologramma/body.html
    defaultScale: '14 14 14',
    defaultPosition: '0 0 -8',
    defaultRotation: '0 0 0',
    defaultCustomParams: {
      videoName: 'olo-milone-aerofono',
      videoPath: 'https://iscag-ei.it/wp-content/materiale/ologramma-milone/olo-milone-aerofono.mp4',
      cameraPosition: '0 4 6',
      chromaColor: '0.02 0.08 0.99',
      groundSize: '1000 1000',
      riseHeight: '0.915',
      autoplay: 'false',
      loop: 'false'
    },
    // Parametri scalabili via URL
    allowedParams: [
      'videoName',
      'videoPath',
      'cameraPosition',
      'scale',
      'position',
      'rotation',
      'chromaColor',
      'groundSize',
      'riseHeight',
      'autoplay',
      'loop'
    ],
    requiresAuth: true,
    category: 'ologrammi'
  },

  // Nuove esperienze ologramma Milone
  'olo-milone-bleirot': {
    id: 'olo-milone-bleirot',
    name: 'Ologramma Milone - Bleirot',
    title: 'Ologramma Milone - Bleirot',
    description: "Esperienza video ologramma con chroma key del Bleirot (Milone).",
    modelType: 'ologramma',
    defaultScale: '14 14 14',
    defaultPosition: '0 0 -8',
    defaultRotation: '0 0 0',
    defaultCustomParams: {
      videoName: 'olo-milone-bleirot',
      videoPath: '/assets/olo-milone-bleirot.mp4',
      cameraPosition: '0 4 6',
      chromaColor: '0.02 0.08 0.99',
      groundSize: '1000 1000',
      riseHeight: '0.915',
      autoplay: 'false',
      loop: 'false'
    },
    allowedParams: [
      'videoName',
      'videoPath',
      'cameraPosition',
      'scale',
      'position',
      'rotation',
      'chromaColor',
      'groundSize',
      'riseHeight',
      'autoplay',
      'loop'
    ],
    requiresAuth: true,
    category: 'ologrammi'
  },

  'olo-milone-castrum': {
    id: 'olo-milone-castrum',
    name: 'Ologramma Milone - Castrum',
    title: 'Ologramma Milone - Castrum',
    description: "Esperienza video ologramma con chroma key del Castrum (Milone).",
    modelType: 'ologramma',
    defaultScale: '14 14 14',
    defaultPosition: '0 0 -8',
    defaultRotation: '0 0 0',
    defaultCustomParams: {
      videoName: 'olo-milone-castrum',
      videoPath: '/assets/olo-milone-castrum.mp4',
      cameraPosition: '0 4 6',
      chromaColor: '0.02 0.08 0.99',
      groundSize: '1000 1000',
      riseHeight: '0.915',
      autoplay: 'false',
      loop: 'false'
    },
    allowedParams: [
      'videoName',
      'videoPath',
      'cameraPosition',
      'scale',
      'position',
      'rotation',
      'chromaColor',
      'groundSize',
      'riseHeight',
      'autoplay',
      'loop'
    ],
    requiresAuth: true,
    category: 'ologrammi'
  },

  'olo-milone-ossidionali': {
    id: 'olo-milone-ossidionali',
    name: 'Ologramma Milone - Ossidionali',
    title: 'Ologramma Milone - Ossidionali',
    description: "Esperienza video ologramma con chroma key degli Ossidionali (Milone).",
    modelType: 'ologramma',
    defaultScale: '14 14 14',
    defaultPosition: '0 0 -8',
    defaultRotation: '0 0 0',
    defaultCustomParams: {
      videoName: 'olo-milone-ossidionali',
      videoPath: '/assets/olo-milone-ossidionali.mp4',
      cameraPosition: '0 4 6',
      chromaColor: '0.02 0.08 0.99',
      groundSize: '1000 1000',
      riseHeight: '0.915',
      autoplay: 'false',
      loop: 'false'
    },
    allowedParams: [
      'videoName',
      'videoPath',
      'cameraPosition',
      'scale',
      'position',
      'rotation',
      'chromaColor',
      'groundSize',
      'riseHeight',
      'autoplay',
      'loop'
    ],
    requiresAuth: true,
    category: 'ologrammi'
  },

  'olo-milone-piccioni': {
    id: 'olo-milone-piccioni',
    name: 'Ologramma Milone - Piccioni',
    title: 'Ologramma Milone - Piccioni',
    description: "Esperienza video ologramma con chroma key dei Piccioni (Milone).",
    modelType: 'ologramma',
    defaultScale: '14 14 14',
    defaultPosition: '0 0 -8',
    defaultRotation: '0 0 0',
    defaultCustomParams: {
      videoName: 'olo-milone-piccioni',
      videoPath: '/assets/olo-milone-piccioni.mp4',
      cameraPosition: '0 4 6',
      chromaColor: '0.02 0.08 0.99',
      groundSize: '1000 1000',
      riseHeight: '0.915',
      autoplay: 'false',
      loop: 'false'
    },
    allowedParams: [
      'videoName',
      'videoPath',
      'cameraPosition',
      'scale',
      'position',
      'rotation',
      'chromaColor',
      'groundSize',
      'riseHeight',
      'autoplay',
      'loop'
    ],
    requiresAuth: true,
    category: 'ologrammi'
  },

  'olo-milone-storia-istituto': {
    id: 'olo-milone-storia-istituto',
    name: 'Ologramma Milone - Storia Istituto',
    title: 'Ologramma Milone - Storia Istituto',
    description: "Esperienza video ologramma con chroma key della Storia dell'Istituto (Milone).",
    modelType: 'ologramma',
    defaultScale: '14 14 14',
    defaultPosition: '0 0 -8',
    defaultRotation: '0 0 0',
    defaultCustomParams: {
      videoName: 'olo-milone-storia-istituto',
      videoPath: '/assets/olo-milone-storia-istituto.mp4',
      cameraPosition: '0 4 6',
      chromaColor: '0.02 0.08 0.99',
      groundSize: '1000 1000',
      riseHeight: '0.915',
      autoplay: 'false',
      loop: 'false'
    },
    allowedParams: [
      'videoName',
      'videoPath',
      'cameraPosition',
      'scale',
      'position',
      'rotation',
      'chromaColor',
      'groundSize',
      'riseHeight',
      'autoplay',
      'loop'
    ],
    requiresAuth: true,
    category: 'ologrammi'
  },

  'olo-milone-telefonobell': {
    id: 'olo-milone-telefonobell',
    name: 'Ologramma Milone - Telefono Bell',
    title: 'Ologramma Milone - Telefono Bell',
    description: "Esperienza video ologramma con chroma key del Telefono Bell (Milone).",
    modelType: 'ologramma',
    defaultScale: '14 14 14',
    defaultPosition: '0 0 -8',
    defaultRotation: '0 0 0',
    defaultCustomParams: {
      videoName: 'olo-milone-telefonobell',
      videoPath: '/assets/olo-milone-telefonobell.mp4',
      cameraPosition: '0 4 6',
      chromaColor: '0.02 0.08 0.99',
      groundSize: '1000 1000',
      riseHeight: '0.915',
      autoplay: 'false',
      loop: 'false'
    },
    allowedParams: [
      'videoName',
      'videoPath',
      'cameraPosition',
      'scale',
      'position',
      'rotation',
      'chromaColor',
      'groundSize',
      'riseHeight',
      'autoplay',
      'loop'
    ],
    requiresAuth: true,
    category: 'ologrammi'
  },

  'olo-milone-telegrafia': {
    id: 'olo-milone-telegrafia',
    name: 'Ologramma Milone - Telegrafia',
    title: 'Ologramma Milone - Telegrafia',
    description: "Esperienza video ologramma con chroma key della Telegrafia (Milone).",
    modelType: 'ologramma',
    defaultScale: '14 14 14',
    defaultPosition: '0 0 -8',
    defaultRotation: '0 0 0',
    defaultCustomParams: {
      videoName: 'olo-milone-telegrafia',
      videoPath: '/assets/olo-milone-telegrafia.mp4',
      cameraPosition: '0 4 6',
      chromaColor: '0.02 0.08 0.99',
      groundSize: '1000 1000',
      riseHeight: '0.915',
      autoplay: 'false',
      loop: 'false'
    },
    allowedParams: [
      'videoName',
      'videoPath',
      'cameraPosition',
      'scale',
      'position',
      'rotation',
      'chromaColor',
      'groundSize',
      'riseHeight',
      'autoplay',
      'loop'
    ],
    requiresAuth: true,
    category: 'ologrammi'
  },

  // Esperienze AR con Image Targets
  'boldrino': {
    id: 'boldrino',
    name: 'Boldrino',
    title: 'Boldrino - Esperienza AR',
    description: 'Esperienza AR con image target per Boldrino con controlli play/pause',
    modelType: 'genericAR',
    defaultCustomParams: {
      targetName: 'quadro-bordino',
      videoName: 'boldrino',
      videoPath: 'https://iscag-ei.it/wp-content/materiale/immaginianimate/boldrino.mp4',
      imagePath: 'https://iscag-ei.it/wp-content/materiale/immaginianimate/boldrinoscan.png',
      thumb: 'https://iscag-ei.it/wp-content/materiale/immaginianimate/ppboldrino.png',
      height: '1',
      width: '1',
      cameraPosition: '0 4 10',
      lightIntensity: '1'
    },
    allowedParams: ['targetName', 'videoName', 'videoPath', 'imagePath', 'thumb', 'height', 'width', 'cameraPosition', 'lightIntensity'],
    requiresAuth: false, // AR experiences typically don't require auth for QR codes
    category: 'ar'
  },

  'filippo-nicolai': {
    id: 'filippo-nicolai',
    name: 'Filippo Nicolai',
    title: 'Filippo Nicolai - Esperienza AR',
    description: 'Esperienza AR con image target per il quadro di Filippo Nicolai',
    modelType: 'genericAR',
    defaultCustomParams: {
      targetName: 'filippo-nicolai-quadro',
      videoName: 'filippo-nicolai-video',
      videoPath: 'https://iscag-ei.it/wp-content/materiale/immaginianimate/filippo-nicolai-video.mp4',
      imagePath: 'https://iscag-ei.it/wp-content/materiale/immaginianimate/nicolaiscan.png',
      cameraPosition: '0 4 10',
      lightIntensity: '1'
    },
    allowedParams: ['targetName', 'videoName', 'videoPath', 'imagePath', 'thumb', 'height', 'width', 'cameraPosition', 'lightIntensity'],
    requiresAuth: false,
    category: 'ar'
  },

  'mario-fiore': {
    id: 'mario-fiore',
    name: 'Mario Fiore',
    title: 'Mario Fiore - Esperienza AR',
    description: 'Esperienza AR con image target per Mario Fiore',
    modelType: 'genericAR',
    defaultCustomParams: {
      targetName: 'mario-fiore',
      videoName: 'video-mario-fiore',
      videoPath: 'https://iscag-ei.it/wp-content/materiale/immaginianimate/video-mario-fiore.mp4',
      imagePath: 'https://iscag-ei.it/wp-content/materiale/immaginianimate/mariofiorescan.png',
      cameraPosition: '0 4 10',
      lightIntensity: '1'
    },
    allowedParams: ['targetName', 'videoName', 'videoPath', 'imagePath', 'thumb', 'height', 'width', 'cameraPosition', 'lightIntensity'],
    requiresAuth: false,
    category: 'ar'
  }
}

// Genera URL dedicato per un'esperienza
export const generateExperienceUrl = (
  experienceId: string,
  params: Record<string, string> = {},
  baseUrl?: string
): string => {
  const base = baseUrl || appBase()
  const experience = EXPERIENCES[experienceId]

  if (!experience) {
    throw new Error(`Esperienza non trovata: ${experienceId}`)
  }

  // Costruisci l'URL base
  let url = `${base}/experience/${experienceId}`

  // Aggiungi parametri validi
  const validParams: Record<string, string> = {}
  Object.entries(params).forEach(([key, value]) => {
    if (experience.allowedParams?.includes(key)) {
      validParams[key] = value
    }
  })

  // Aggiungi parametri all'URL se presenti
  if (Object.keys(validParams).length > 0) {
    const queryString = new URLSearchParams(validParams).toString()
    url += `?${queryString}`
  }

  return url
}

// Genera URL completo per condivisione
export const generateShareableExperienceUrl = (
  experienceId: string,
  params: Record<string, string> = {},
  includeAuth: boolean = false
): string => {
  const base = appBase()
  let url = generateExperienceUrl(experienceId, params, base)

  if (includeAuth) {
    // Se richiesto, genera un URL di login che porta direttamente all'esperienza
    const authSystem = AuthSystem.getInstance()
    const loginUrl = authSystem.generateLoginUrlWithRedirect(url)
    return `${window.location.origin}${loginUrl}`
  }

  return `${window.location.origin}${url}`
}

// Genera URL di login con reindirizzamento diretto all'esperienza
export const generateExperienceLoginUrl = (
  experienceId: string,
  params: Record<string, string> = {}
): string => {
  const authSystem = AuthSystem.getInstance()
  const experienceUrl = generateExperienceUrl(experienceId, params)
  return authSystem.generateLoginUrlWithRedirect(experienceUrl)
}

// Valida i parametri per un'esperienza
export const validateExperienceParams = (
  experienceId: string,
  params: Record<string, string>
): Record<string, string> => {
  const experience = EXPERIENCES[experienceId]
  if (!experience) {
    return {}
  }

  const validParams: Record<string, string> = {}
  Object.entries(params).forEach(([key, value]) => {
    if (experience.allowedParams?.includes(key)) {
      validParams[key] = value
    }
  })

  return validParams
}

// Ottieni configurazione esperienza con parametri personalizzati
export const getExperienceConfig = (
  experienceId: string,
  params: Record<string, string> = {}
): ExperienceConfig & { customParams: Record<string, string> } => {
  const experience = EXPERIENCES[experienceId]
  if (!experience) {
    throw new Error(`Esperienza non trovata: ${experienceId}`)
  }

  const customParams = validateExperienceParams(experienceId, params)

  // Aggiungi i parametri di default se non specificati
  if (!customParams.scale && experience.defaultScale) {
    customParams.scale = experience.defaultScale
  }
  if (!customParams.position && experience.defaultPosition) {
    customParams.position = experience.defaultPosition
  }
  if (!customParams.rotation && experience.defaultRotation) {
    customParams.rotation = experience.defaultRotation
  }

  // Merge dei defaultCustomParams specifici del template (senza sovrascrivere parametri URL)
  if (experience.defaultCustomParams) {
    Object.entries(experience.defaultCustomParams).forEach(([key, value]) => {
      if (customParams[key] === undefined || customParams[key] === null) {
        customParams[key] = value
      }
    })
  }

  // Aggiungi l'envmap se presente nella configurazione dell'esperienza
  if (experience.envmap) {
    customParams.envmap = JSON.stringify(experience.envmap)
  }

  return {
    ...experience,
    customParams
  }
}

// Lista tutte le esperienze disponibili
export const getAllExperiences = (): ExperienceConfig[] => {
  return Object.values(EXPERIENCES)
}

// Filtra esperienze per categoria
export const getExperiencesByCategory = (category: string): ExperienceConfig[] => {
  return getAllExperiences().filter(exp => exp.category === category)
}

// Verifica se un'esperienza esiste
export const experienceExists = (experienceId: string): boolean => {
  return experienceId in EXPERIENCES
}

// Estrai experienceId dal pathname dell'URL
export const extractExperienceIdFromPath = (pathname: string): string | null => {
  try {
    // Cerca il pattern /experience/[id] nel pathname
    const match = pathname.match(/\/experience\/([^\/\?]+)/)
    if (match && match[1]) {
      return match[1]
    }
    return null
  } catch (error) {
    console.error('Errore nell\'estrazione dell\'experienceId:', error)
    return null
  }
}

// Ottieni categorie disponibili
export const getAvailableCategories = (): string[] => {
  const categories = new Set(getAllExperiences().map(exp => exp.category).filter((cat): cat is string => Boolean(cat)))
  return Array.from(categories)
}

// Genera URL ottimizzato per QR Code - più corto e diretto
export const generateQRCodeUrl = (
  experienceId: string,
  params: Record<string, string> = {},
  baseUrl?: string
): string => {
  const base = baseUrl || appBase()
  const experience = EXPERIENCES[experienceId]

  if (!experience) {
    throw new Error(`Esperienza non trovata: ${experienceId}`)
  }

  // URL più corto per QR codes: /qr/[id] invece di /experience/[id]
  let url = `${base}/qr/${experienceId}`

  // Aggiungi solo parametri essenziali per QR codes
  const validParams: Record<string, string> = {}
  Object.entries(params).forEach(([key, value]) => {
    if (experience.allowedParams?.includes(key)) {
      validParams[key] = value
    }
  })

  if (Object.keys(validParams).length > 0) {
    const queryString = new URLSearchParams(validParams).toString()
    url += `?${queryString}`
  }

  return url
}

// Genera URL completo per QR Code con dominio
export const generateQRCodeFullUrl = (
  experienceId: string,
  params: Record<string, string> = {}
): string => {
  const qrUrl = generateQRCodeUrl(experienceId, params)
  return `${window.location.origin}${qrUrl}`
}

// Estrai experienceId anche dal pattern QR
export const extractExperienceIdFromQRPath = (pathname: string): string | null => {
  try {
    // Cerca il pattern /qr/[id] nel pathname
    const match = pathname.match(/\/qr\/([^\/\?]+)/)
    if (match && match[1]) {
      return match[1]
    }
    return null
  } catch (error) {
    console.error('Errore nell\'estrazione dell\'experienceId da QR:', error)
    return null
  }
}

// Funzione helper per verificare se è un URL QR
export const isQRUrl = (pathname: string): boolean => {
  return pathname.startsWith('/qr/')
}

// Genera configurazione per esperienza da URL QR
export const getExperienceConfigFromQR = (
  pathname: string,
  searchParams: URLSearchParams
): (ExperienceConfig & { customParams: Record<string, string> }) | null => {
  const experienceId = extractExperienceIdFromQRPath(pathname)
  if (!experienceId) {
    return null
  }

  const params: Record<string, string> = {}
  searchParams.forEach((value, key) => {
    params[key] = value
  })

  try {
    return getExperienceConfig(experienceId, params)
  } catch (error) {
    console.error('Errore nel caricamento configurazione esperienza da QR:', error)
    return null
  }
}

// Utility per generare URL QR per esperienze AR comuni
export const generateARExperienceQR = {
  // Boldrino con controlli play/pause
  boldrino: (customParams?: Record<string, string>) =>
    generateQRCodeFullUrl('boldrino', customParams),

  // Filippo Nicolai
  filippoNicolai: (customParams?: Record<string, string>) =>
    generateQRCodeFullUrl('filippo-nicolai', customParams),

  // Mario Fiore
  marioFiore: (customParams?: Record<string, string>) =>
    generateQRCodeFullUrl('mario-fiore', customParams),

  // Genera QR per qualsiasi esperienza AR
  custom: (experienceId: string, customParams?: Record<string, string>) =>
    generateQRCodeFullUrl(experienceId, customParams)
}

// Esempi di utilizzo per QR codes:
// 
// // QR per Boldrino con controlli di default
// const boldrinoQR = generateARExperienceQR.boldrino()
// // Risultato: https://yourdomain.com/qr/boldrino
//
// // QR per Boldrino con parametri personalizzati
// const boldrinoCustomQR = generateARExperienceQR.boldrino({ 
//   thumb: 'https://custom-thumb.png',
//   height: '2' 
// })
// // Risultato: https://yourdomain.com/qr/boldrino?thumb=https%3A%2F%2Fcustom-thumb.png&height=2
//
// // QR per esperienza personalizzata
// const customQR = generateARExperienceQR.custom('my-experience', { param: 'value' })
// // Risultato: https://yourdomain.com/qr/my-experience?param=value 